<div class="booking-details">

  <!-- SIDEBAR -->
  <!-- <div *ngIf="checkListDetails$ | async as details" class="reservation-sidebar">

  


   
    <h2 class="reservation-heading">CHECKLIST</h2>
    

   
    <h5>Details:</h5>
    <ul>
      <li>
        <span class="key">Title:</span>
        <span class="value">{{details.title}}</span>
      </li>
      <li>
        <span class="key">First Names:</span>
        <span class="value">{{details.firstNames}}</span>
      </li>
      <li>
        <span class="key">Last Name:</span>
        <span class="value">{{details.lastName}}</span>
      </li>
      <li>
        <span class="key">Email Address:</span>
        <span class="value">{{details.email}}</span>
      </li>
      <li>
        <span class="key">Gender:</span>
        <span class="value">{{details.gender}}</span>
      </li>
      <li>
        <span class="key">Country:</span>
        <span class="value">{{details.country}}</span>
      </li>
      <li>
        <span class="key">ID / Passport No.:</span>
        <span class="value">{{details.idNumber}}</span>
      </li>
      <li>
        <span class="key">Mobile Phone:</span>
        <span class="value">{{details.mobilePhone}}</span>
      </li>
      <li>
        <span class="key">Name Of Church:</span>
        <span class="value">{{details.nameOfChurch}}</span>
      </li>
      <li>
        <span class="key">Track Sessions:</span>
        <span class="value">{{details.trackSessions?.length}}</span>
        <span *ngIf="details.trackSessions?.length > 3" style="color: red">
          You selected more than required. Only first 3 will be used.
        </span>
      </li>
      <li>
        <span class="key">Include In Business?:</span>
        <span class="value">{{details.includeInBusiness}}</span>
      </li>
      <li>
        <span class="key">Expertise:</span>
        <span class="value">{{details.expertise}}</span>
      </li>
      <li>
        <span class="key">Arrival Date:</span>
        <span class="value">{{details.arrivalDate | date}}</span>
      </li>
      <li>
        <span class="key">Departure Date:</span>
        <span class="value">{{details.departureDate | date}}</span>
      </li>
      <li>
        <span class="key">Day 1 Meal:</span>
        <span class="value">{{details.meal1}}</span>
      </li>
      <li>
        <span class="key">Day 2 Meal:</span>
        <span class="value">{{details.meal2}}</span>
      </li>
      <li>
        <span class="key">Day 3 Meal:</span>
        <span class="value">{{details.meal3}}</span>
      </li>
      <li>
        <span class="key">Other Information:</span>
        <span class="value">{{details.otherInfo}}</span>
      </li>
      <li>
        <span class="key">Package Choice:</span>
        <span class="value">{{details.packageChoice}}</span>
      </li>
      <li>
        <span class="key">Hotel Choice 1:</span>
        <span class="value">{{details.hotelChoice1}}</span>
      </li>
      <li>
        <span class="key">Hotel Choice 2:</span>
        <span class="value">{{details.hotelChoice2}}</span>
      </li>
      <li>
        <span class="key">Hotel Choice 3:</span>
        <span class="value">{{details.hotelChoice3}}</span>
      </li>
    </ul>


    
    <h5>Tours(optional): </h5>
    <ul *ngIf="details.tours as tours; else noTour">
      <li *ngFor="let tour of tours">
        <span>{{tour}}</span>
        <span>${{tourPriceMap[tour]}}</span>
      </li>
    </ul>
    <ng-template #noTour>
      <ul>
        <li>
          <span>Tour Added?</span>
          <span>Not Yet</span>
        </li>
      </ul>
    </ng-template>

    
    <hr />
    <ul>
      <li>
        <span class="price-label">Cummulative Price:</span>
        <span class="price-label">${{details.bookingPrice}}</span>
      </li>
    </ul>
  </div> -->

  <!-- STEP -->
  <div class="tab-section">
    <router-outlet></router-outlet>
    <!-- END / STEP -->
  </div>
</div>


// WEBPACK FOOTER //
// /Users/abassey/side-proj/emp21-new/src/app/booking/containers/add-booking/add-booking.component.html